import { render, staticRenderFns } from "./PlanService.vue?vue&type=template&id=0f594d5b"
import script from "./PlanService.vue?vue&type=script&lang=js"
export * from "./PlanService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports